import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from '../components/Modal';
import { header } from '../components/header.encry';
import { toast } from 'react-toastify';

const initialForm = { name: '', type: '', stock: [] };

const ComponentsManager = () => {
  const [components, setComponents] = useState([]);
  const [formData, setFormData] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);

  const fetchComponents = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_PEGASUS_API_URL}/components`, header());
      setComponents(res.data);
    } catch (err) {
      console.error('Error fetching components', err);
    }
  };

  useEffect(() => {
    fetchComponents();
  }, []);

  const openAdd = () => {
    setEditingId(null);
    setFormData(initialForm);
  };

  const openEdit = (comp) => {
    setEditingId(comp._id);
    setFormData({ name: comp.name, type: comp.type, stock: comp.stock || [] });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleStockChange = (index, field, value) => {
    const updated = [...formData.stock];
    updated[index] = { ...updated[index], [field]: value };
    setFormData(prev => ({ ...prev, stock: updated }));
  };

  const addStockRow = () => {
    setFormData(prev => ({ ...prev, stock: [...prev.stock, { store_id: '', stock: 0 }] }));
  };

  const removeStockRow = (index) => {
    const updated = formData.stock.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, stock: updated }));
  };

  const handleSubmit = async () => {
    try {
      if (editingId) {
        await axios.put(`${process.env.REACT_APP_PEGASUS_API_URL}/components/${editingId}`, formData, header());
        toast.success('Composant mis à jour avec succès');
      } else {
        await axios.post(`${process.env.REACT_APP_PEGASUS_API_URL}/components`, formData, header());
        toast.success('Composant ajouté avec succès');
      }
      fetchComponents();
    } catch (err) {
      console.error('Save error', err);
      toast.error("Erreur lors de l'enregistrement du composant");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Confirmer la suppression ?')) return;
    try {
      await axios.delete(`${process.env.REACT_APP_PEGASUS_API_URL}/components/${id}`, header());
      toast.success('Composant supprimé avec succès');
      fetchComponents();
    } catch (err) {
      console.error('Delete error', err);
      toast.error("Erreur lors de la suppression du composant");
    }
  };

  const totalStock = (comp) => comp.stock?.reduce((acc, s) => acc + Number(s.stock || 0), 0);

  return (
    <div className="container mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Composants</h2>
        <button className="btn btn-success" onClick={openAdd} data-bs-toggle="modal" data-bs-target="#componentModal">Ajouter</button>
      </div>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Type</th>
            <th>Stock total</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {components.map(comp => (
            <tr key={comp._id}>
              <td>{comp.name}</td>
              <td>{comp.type}</td>
              <td>{totalStock(comp)}</td>
              <td>
                <button className="btn btn-primary btn-sm me-2" onClick={() => openEdit(comp)} data-bs-toggle="modal" data-bs-target="#componentModal">Modifier</button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(comp._id)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal modalId="componentModal" title={editingId ? 'Modifier le composant' : 'Ajouter un composant'} submitLabel={editingId ? 'Modifier' : 'Ajouter'} onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Nom</label>
          <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} />
        </div>
        <div className="mb-3">
          <label className="form-label">Type</label>
          <input type="text" className="form-control" name="type" value={formData.type} onChange={handleChange} />
        </div>
        <div className="mb-3">
          <label className="form-label">Stocks par magasin</label>
          {formData.stock.map((st, idx) => (
            <div key={idx} className="d-flex mb-2">
              <input type="text" className="form-control me-2" placeholder="store_id" value={st.store_id} onChange={e => handleStockChange(idx, 'store_id', e.target.value)} />
              <input type="number" className="form-control me-2" placeholder="Stock" value={st.stock} onChange={e => handleStockChange(idx, 'stock', e.target.value)} />
              <button type="button" className="btn btn-outline-danger" onClick={() => removeStockRow(idx)}>&times;</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-secondary" onClick={addStockRow}>Ajouter un stock</button>
        </div>
      </Modal>
    </div>
  );
};

export default ComponentsManager;
